export default "__VITE_ASSET__CEZrhEwT__"